<template>
  <v-container>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <h3>Enter Your New Password:</h3>
      </v-col>
    </v-row>

    <v-spacer></v-spacer>

    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          label="New Password"
          outlined
          v-model="password"
          :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show1 ? 'text' : 'password'"
          name="password"
          hint="At least 8 characters"
          counter
          @click:append="show1 = !show1"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          label="Confirm New Password"
          outlined
          v-model="confirmPassword"
          :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
          :rules="[rules.required, rules.min]"
          :type="show2 ? 'text' : 'password'"
          name="confirmPassword"
          hint="At least 8 characters"
          counter
          @click:append="show2 = !show2"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        sm="6"
      >
        <v-btn
          color="primary"
          @click="changePassword()"
        >
          Change Password
        </v-btn>
      </v-col>
    </v-row>
    
  </v-container>
</template>


<script>
import { changePassword } from '../services/users';

export default {
  components: {
  },
  data() {
    return {
      rules: {
          required: value => !!value || 'Required.',
          min: v => v.length >= 8 || 'Min 8 characters',
          emailMatch: () => (`The email and password you entered don't match`),
      },
      show1: false,
      show2: false,
      password: '',
      confirmPassword: '',
    };
  },
  async mounted() {
    // This gets all of the jobs
    await this.getData();
  },
  methods: {
    async getData() {
      console.log('this is the token');
      console.log(this.$route.params.token);
    },
    async changePassword(){
      let payload = {
        'token': this.$route.params.token,
        'password': this.password
      }
      if (this.password != this.confirmPassword){
        this.$emit('snackbar', { text: 'Passwords do not match', color: 'red' });
        return
      }
      try {
        await changePassword(payload);
        this.$router.push({ name: 'pasword-reset-success' });
      } catch (e) {
        if (e.response.status === 502) {
          this.$emit('snackbar', { text: '502 Bad Gateway', color: 'red' });
        } else {
          this.$emit('snackbar', { text: 'Unable to update password.', color: 'red' });
        }
      }
    }
  },
};
</script>